// extracted by mini-css-extract-plugin
export default {"x":"A6jmPX"};